<template>
  <section>
    <PageTitle title="O firmie" slogan="Jesteśmy na rynku od 2005r. " />
    <div
      class="container px-4 pt-32 mx-auto text-center sm:px-0 lg:px-0 xl:px-0 2xl:px-64 md:pt-40 lg:pt-40 2xl:pt-56 sm:text-left"
    >
      <main>
        <div class="container px-5 pt-12 pb-24 mx-auto">
          <div class="mb-20 text-center">
            <h1 class="mb-4 text-2xl font-medium text-center text-gray-900 sm:text-3xl title-font">
              <strong>Haft Poznań</strong> | P. Woźny
            </h1>
            <p class="mx-auto mb-4 text-base leading-relaxed">
              Nasza firma istnieje na rynku od stycznia
              <strong>2005 roku</strong>. Realizujemy zlecenia z całego kraju oraz Unii Europejskiej.
            </p>

            <p class="mx-auto text-base leading-relaxed">
              Maszyny którymi dysponujemy to przemysłowe automaty hafciarskie wysokiej klasy:
              <strong>TAJIMA, SWF, Barudan.</strong>
            </p>
            <p class="mx-auto mb-4 text-base leading-relaxed">
              Dzięki nabytemu doświadczeniu przy użyciu wysokogatunkowych nici wykonujemy hafty o najlepszej jakości, w
              różnych technikach hafciarskich. Dzięki stałej współpracy ze szwalniami zapewniamy masową i kompleksową
              usługę haftu klasycznego i 3D na półprodukcie lub produkcie gotowym.
            </p>
            <p>Realizujemy zlecenia z całego kraju oraz Unii Europejskiej.</p>
          </div>
          <div class="flex flex-wrap -mx-2 lg:w-4/5 sm:mx-auto sm:mb-2">
            <div class="w-full p-2 sm:w-1/2">
              <div class="flex items-center h-full p-4 bg-gray-200 rounded">
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="3"
                  class="flex-shrink-0 w-6 h-6 mr-4 text-blue-500"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                  <path d="M22 4L12 14.01l-3-3" />
                </svg>
                <span class="font-medium title-font">Firma od 2005 roku</span>
              </div>
            </div>
            <div class="w-full p-2 sm:w-1/2">
              <div class="flex items-center h-full p-4 bg-gray-200 rounded">
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="3"
                  class="flex-shrink-0 w-6 h-6 mr-4 text-blue-500"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                  <path d="M22 4L12 14.01l-3-3" />
                </svg>
                <span class="font-medium title-font">Maszyny Tajima, SWFm Burdan.</span>
              </div>
            </div>
            <div class="w-full p-2 sm:w-1/2">
              <div class="flex items-center h-full p-4 bg-gray-200 rounded">
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="3"
                  class="flex-shrink-0 w-6 h-6 mr-4 text-blue-500"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                  <path d="M22 4L12 14.01l-3-3" />
                </svg>
                <span class="font-medium title-font">Doświadczenie</span>
              </div>
            </div>
            <div class="w-full p-2 sm:w-1/2">
              <div class="flex items-center h-full p-4 bg-gray-200 rounded">
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="3"
                  class="flex-shrink-0 w-6 h-6 mr-4 text-blue-500"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                  <path d="M22 4L12 14.01l-3-3" />
                </svg>
                <span class="font-medium title-font">Haft klasyczny oraz 3d</span>
              </div>
            </div>
            <div class="w-full p-2 sm:w-1/2">
              <div class="flex items-center h-full p-4 bg-gray-200 rounded">
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="3"
                  class="flex-shrink-0 w-6 h-6 mr-4 text-blue-500"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                  <path d="M22 4L12 14.01l-3-3" />
                </svg>
                <span class="font-medium title-font">Zlecenia na terenie całej UE</span>
              </div>
            </div>
            <div class="w-full p-2 sm:w-1/2">
              <div class="flex items-center h-full p-4 bg-gray-200 rounded">
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="3"
                  class="flex-shrink-0 w-6 h-6 mr-4 text-blue-500"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
                  <path d="M22 4L12 14.01l-3-3" />
                </svg>
                <span class="font-medium title-font">Masowa produkacja</span>
              </div>
            </div>
          </div>
          <div class="w-full mt-20">
            <div class="flex items-center justify-center">
              <router-link
                class="px-6 py-2 text-xl font-bold text-white bg-blue-600 rounded-lg transition duration-500 ease-in-out transform motion-reduce:transform-none hover:-translate-y-1 hover:bg-blue-400"
                :to="'/oferta'"
                >Sprawdź nasza oferte</router-link
              >
            </div>
          </div>
        </div>
      </main>
    </div>
  </section>
</template>

<script>
import PageTitle from "../components/PageTitle";
export default {
  name: "About",
  components: {
    PageTitle,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
